export function videoPopupOpener() {
    let $body = $("body");
    let newVideoPopup;
    let focusAfterClose;
    $(".video-popup-opener").on("click", function (e) {
        let $this = $(this);
        focusAfterClose = $(this);
        let videoSrc = $this.attr("href");
        $body.addClass("video-popup-opened");
        e.preventDefault();
        newVideoPopup = $("<div class='video-popup'>" + "<div class='video-popup-holder'>" + "<video autoplay playsinline controls>\n" + "  <source src=" + videoSrc + " type=\"video/mp4\">\n" + "Your browser does not support the video tag.\n" + "</video><a href=\"#\" class=\"close-video-popup\">\n" + "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.31 13.31\">\n" + "<path fill=\"#ffffff\" fill-rule=\"evenodd\"\n" + "d=\"M1.71.29l5,5L11.61.29A1,1,0,0,1,13,.29a1,1,0,0,1,0,1.42l-4.95,5L13,11.61A1,1,0,0,1,11.61,13L6.66,8.07,1.71,13A1,1,0,0,1,.29,13a1,1,0,0,1,0-1.41l5-4.95L.29,1.71A1,1,0,0,1,1.71.29Z\"/>\n" + "</svg>\n" + "</a></div>" + "</div>")
        $body.find(".footer").before(newVideoPopup);
        $body.find(".video-popup video").focus();
    });

    $body.on("click", ".close-video-popup", function (e) {
        e.preventDefault();
        $body.removeClass("video-popup-opened");
        focusAfterClose.focus();
        setTimeout(function () {
            $body.find(".video-popup").remove();
        }, 500);
    });

    $(document).keyup(function () {
        if (event.keyCode === 27) {
            $body.removeClass("video-popup-opened");
            focusAfterClose.focus();
            setTimeout(function () {
                $body.find(".video-popup").remove();
            }, 500);
        }
    });
    $body.focusin(function (e) {
        if (!$(e.target).parents().hasClass('video-popup')) {
            if ($body.hasClass("video-popup-opened")) {
                $body.removeClass("video-popup-opened");
                focusAfterClose.focus();
                setTimeout(function () {
                    $body.find(".video-popup").remove();
                }, 500);
            }
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/videoPopupOpener.js